import BaseNotification from '../BaseNotification'

export default class PassengerAwaitingConfirmation extends BaseNotification {
  get iconClass(): string {
    return 'sc-icon-person-hollow'
  }
}
